import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import withSurveyDataLoad from '@booking/library/withSurveyDataInit/withSurveyDataLoad';
import { Steps } from '@booking/pages/liveqHome/liveqSteps';
const LiveqHome = () => {
    return (_jsx(Steps, {}));
};
export default withSurveyDataLoad(observer(LiveqHome));
